// Formatting utilities for traceability displays

export const kgFmt = (v: number | null | undefined): string =>
  v == null ? "—" : `${Number(v).toFixed(2)} kg`;

export const pcsFmt = (v: number | null | undefined): string =>
  v == null ? "—" : `${Number(v)} pcs`;

export const sum = <T>(
  arr: T[],
  sel: (item: T) => number | null | undefined
): number => arr.reduce((a, r) => a + (Number(sel(r)) || 0), 0);

